import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class UserModel {
  uid: string = ""
  spaceUserId: string = ""
  firstname: string = ""
  lastname: string = ""
  email: string = ""
  phone: string = ""
  title: string = ""
  roles: string[] = []

  constructor(
    data: {
      uid: string
      spaceUserId: string
      firstname: string
      lastname: string
      email: string
      phone: string
      title: string
      roles: string[]
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.spaceUserId = data.spaceUserId
      this.firstname = data.firstname
      this.lastname = data.lastname
      this.email = data.email
      this.phone = data.phone
      this.title = data.title
      this.roles = data.roles
    }
  }
}
